import Vue from 'vue';

const maps = {};

maps.articleCategory = {
  1: '案例解析',
  2: '最新资讯',
  3: '企业动态',
};

maps.balanceType = {
  0: '新账户赠送',
  1: '充值',
  2: '订单支付',
  3: '补缴费用',
  4: '订单退款',
  5: '顺丰取资料服务',
  6: '顺丰取资料服务退款',
  7: '申请人退款',
  8: '补差价退款',
  9: '保险订单支付',
  10: '保险订单退款',
  11: '新用户首本优惠',
  12: '顺丰回寄运费退款',
  13: '修改赴馆时间',
  14: '旅游保险退款',
  15: '线下充值',
  16: '申请人部分退款',
  17: '账户余额退款',
  18: '提现',
  19: '自选保险支付',
  20: '修改保期费用',
  21: '发票补差价支付',
  22: '发票补差价退款',
  23: '机票订单支付',
  24: '机票补差价支付',
};

maps.INSURANCE_STATUS = {
  0: '待支付',
  1: '待出单',
  2: '已出单',
  3: '已取消',
};

maps.INSURANT_STATUS = {
  0: '待支付',
  1: '未生效',
  2: '已生效',
  3: '退保中',
  4: '退保成功',
};

maps.ORDER_STATUS = {
  0: '已取消',
  1: '待上传资料',
  2: '待填写申请表',
  3: '待支付',
  4: '待邮寄资料',
  5: '办理中',
  6: '已发货',
  // 7: '待评价',
  8: '已完成',
  // 9: '已删除',
  10: '待选择日期',
};

maps.APPLICANT_STATUS = {
  0: '已取消',
  1: '等待预审',
  2: '资料不完善',
  3: '等待送签',
  4: '使馆审核中',
  5: '出签成功',
  6: '拒签',
  7: '退款中',
  8: '退款成功',
  9: '等待预约',
  10: '待确认',
  11: '等待接收资料',
  12: '等待培训',
  13: '待前往使馆',
  14: '拒签(待提交证明)',
  15: '拒签(等待审核)',
  16: '拒签(审核不通过)',
  17: '资料不完善（待退款）',
  18: '预约成功',
};


maps.ORDER_TYPE = {
  1: '飞猪',
};

Vue.prototype.$maps = maps;



// WEBPACK FOOTER //
// ./src/libs/maps.js